import classNames from 'classnames';
import React from 'react';
import { ILeftVsRightKeys } from 'twain-sport-fe-mono/interfaces';
import { ReactComponent as RngParticipantBaseIcon } from '../rng-participant.svg';
import { ReactComponent as RngParticipantRoundBaseIcon } from '../rng-participant-round.svg';
import classes from './RngParticipant.module.scss';

interface IProps extends React.SVGProps<SVGSVGElement> {
    court?: ILeftVsRightKeys;
    type?: 'round' | 'normal';
    className?: string;
}

const defaultProps: Partial<IProps> = {
    court: 'left',
    type: 'round',
};

export const RngParticipantIcon: React.FC<IProps> = (props) => {
    const className = classNames(classes.icon, classes[props.court], props.className);
    return props.type === 'round' ? (
        <RngParticipantRoundBaseIcon
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            className={className}
        />
    ) : (
        <RngParticipantBaseIcon
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            className={className}
        />
    );
};

RngParticipantIcon.defaultProps = defaultProps;
